import { EvideFormStatus, FormTypes } from 'common/enums';
import {
  IEvideInputContentDataInfoHttp,
  IEvideInputContentFormGroupHttp,
  IEvideInputContentFormHttp
} from './evide-input-content-form-http.model';

export class EvideInputContentForm {
  public readonly inputContentGroups: EvideInputContentFormGroup[] = [];

  public status?: EvideFormStatus;
  public statusName?: string;
  public formTypeName?: string;

  private isInfo$ = {
    canEdit: false,
    canDelete: false,
    canPublish: false,
    canArchive: false,
    canPreview: false,
    canShare: false
  }

  constructor(
    public id: number,
    public evideProjectId: number,
    public evideLicenseId: number,
    public evideFormTypeId: number,
    public title: string,
    public formGuid: string,
    public formType: number,
    public formToken: string,
    public description?: string,
    public url?: string,
  ) { }

  public static fromJson(res: IEvideInputContentFormHttp): EvideInputContentForm {
    const form = new this(
      res.id, res.evideProjectId, res.evideLicenseId, res.evideFormTypeId,
      res.title, res.formGuid, res.formType, res.formToken,
      res.description, res.url
    );
    form.status = res.status ? res.status : EvideFormStatus.Draft;
    form.statusName = res.statusName;
    form.isInfo = res.isInfo;
    if (res.inputContentGroupInfos) {
      form.inputContentGroups.push(...res.inputContentGroupInfos.map(item => EvideInputContentFormGroup.fromJson(item)));
    }
    return form;
  }

  public set isInfo(infp) {
    this.isInfo$ = infp;
  }

  public get canPublish(): boolean {
    return this.isInfo$.canPublish;
  }

  public get canEdit(): boolean {
    return this.isInfo$.canEdit;
  }

  public get canArchive(): boolean {
    return this.isInfo$.canArchive;
  }

  public get canDelete(): boolean {
    return this.isInfo$.canDelete;
  }

  public get canShare(): boolean {
    return this.isInfo$.canShare;
  }

  public get canPreview(): boolean {
    return this.isInfo$.canPreview;
  }

}

export class EvideInputContentFormGroup {

  public inputContents: EvideInputContentDataInfo[] = [];

  constructor(
    public id: number,
    public evideInputContentGroupId: number,
    public evideInputContentTitle?: string,
    public evideInputContentDescription?: string,
    public pageBreakTitle?: string,
    public pageBreak?: boolean,
    public sortOrder?: number,
    public inputContentId?: number,
    public isMandatory?: boolean,
    public isUnique?: boolean,
    public isSearch?: boolean,
    public gridVisible?: boolean,
    public detailVisible?: boolean,
    public gridOrder?: number,
    public evideInputContentGuid?: string,
    public dataType?: number,
    public dataTypeName?: string,
    public inputControllerType?: number,
    public inputControllerTypeName?: string,
    public evideInputContentInfos?: EvideInputContentDataInfo[]
  ) { }

  public static fromJson(req: IEvideInputContentFormGroupHttp): EvideInputContentFormGroup {
    const group = new this(
      req.id, req.evideInputContentGroupId, req.evideInputContentTitle, req.evideInputContentDescription,
      req.pageBreakTitle, req.pageBreak, req.sortOrder, req.inputContentId, req.isMandatory,
      req.isUnique, req.isSearch, req.gridVisible, req.detailVisible, req.gridOrder,
      req.evideInputContentGuid, req.dataType, req.dataTypeName, req.inputControllerType, req.inputControllerTypeName,
      req.evideInputContentInfos.map(item => EvideInputContentDataInfo.fromJson(item))
    );

    return group;
  }

}

export class EvideInputContentDataInfo {

  constructor(
    public readonly id: number,
    public dataKey: string,
    public dataValue?: string,
    public evideInputContentId?: number,
    public evideInputContentDataGuid?: string,
    public visible?: boolean
  ) { }

  public static fromJson(req: IEvideInputContentDataInfoHttp): EvideInputContentDataInfo {
    const question = new EvideInputContentDataInfo(
      req.id, req.dataKey, req.dataValue, req.evideInputContentId, req.evideInputContentDataGuid, req.visible
    );
    return question;
  }

}


